<script setup>
import UModal from '@/components/base-components/AccessibleModal.vue'
import { useDownloadsStore } from '@/stores/downloads.store'
const downloads = useDownloadsStore()
</script>

<template>
    <UModal v-model="downloads.reviewOpen" :title="$t('modals.review_sql')" no-footer size="lg">
        <p>{{ downloads.reviewDownload?.title }} · {{ downloads.reviewDownload?.db }}</p>
        <p class="text-muted">{{ $t('modals.review_sql_help') }}</p>
        <p v-if="downloads.reviewLoading" role="status">{{ $t('modals.loading_sql') }}</p>
        <p v-else-if="downloads.reviewError" role="alert">{{ downloads.reviewError }}</p>
        <textarea v-else class="sql-review" :value="downloads.reviewSql" readonly :aria-label="$t('modals.generated_sql')" spellcheck="false" />
        <div class="sql-review-actions">
            <button type="button" class="btn" @click="downloads.reviewOpen = false">{{ $t('modals.cancel') }}</button>
            <button type="button" class="btn btn-primary" :disabled="downloads.reviewLoading || !downloads.reviewSql" @click="downloads.confirmSqlDownload()">{{ $t('dashboard.download') }}</button>
        </div>
    </UModal>
</template>

<style scoped>
.sql-review { width: 100%; height: min(48vh, 28rem); resize: vertical; white-space: pre; overflow: auto; font-family: monospace; font-size: 0.85rem; padding: 0.75rem; background: var(--body-bg); color: var(--main-text-color); border: 1px solid var(--border-color); border-radius: 0.4rem; }
.sql-review-actions { display: flex; justify-content: flex-end; gap: 0.5rem; margin-top: 0.75rem; }
</style>
